<template>
  <div class="app-container">
    <div class="title-row"><span class="title">{{ this.$route.meta.title }}</span></div>
    <!-- 条件筛选 -->
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
        <el-form-item label="文章类型" prop="condition">
          <el-select v-model="condition" placeholder="请选择" @change="changeType">
            <el-option v-for="item in options" :key="item.value" :label="item.label"  :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="文章名称" prop="keyWords">
            <el-input v-model="queryParams.keyWords" clearable placeholder="请输入文章名" @keyup.enter.native="handleQuery"/>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
        </el-form-item>
    </el-form>
    <!-- 表格操作 -->
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button v-hasPermi="['article:manage:edit']" v-if="queryParams.isDelete === 0" type="success" plain size="mini" icon="el-icon-edit" :disabled="single" @click="editArticle">编辑</el-button>
      </el-col>
      <el-col :span="1.5">
       <el-button v-hasPermi="['article:manage:recycle']" v-if="queryParams.isDelete === 0" type="danger" plain size="mini" icon="el-icon-delete" :disabled="multiple" @click="handleToRecycle">批量删除</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['article:manage:remove']" v-if="queryParams.isDelete === 1" type="danger" plain size="mini" icon="el-icon-delete" :disabled="multiple" @click="handleDeleteArticles">批量删除</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['article:manage:back']" v-if="queryParams.isDelete === 1" type="success" plain size="mini" icon="el-icon-refresh-left" :disabled="multiple" @click="handleBack">批量恢复</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList" ></right-toolbar>
    </el-row>
    <!-- 表格展示 -->
    <el-table :data="articleList" @selection-change="selectionChange" v-loading="loading" >
      <!-- 表格列 -->
      <el-table-column type="selection" width="55" />
      <el-table-column prop="articleTitle" label="标题" align="center" />
      <!-- 文章分类 -->
      <el-table-column prop="categoryName" label="分类" width="120" align="center"/>
      <!-- 文章标签 -->
      <el-table-column prop="tagDTOList" label="标签" width="180" align="center">
        <template slot-scope="scope">
          <el-tag v-for="item of scope.row.tagDTOList" :key="item.tagId" style="margin-right:0.2rem;margin-top:0.2rem">{{ item.tagName }}</el-tag>
        </template>
      </el-table-column>
      <!-- 文章浏览量 -->
      <el-table-column prop="viewsCount" label="浏览量" width="80" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.viewsCount">
            {{ scope.row.viewsCount }}
          </span>
          <span v-else>0</span>
        </template>
      </el-table-column>
      <!-- 文章点赞量 -->
      <el-table-column prop="likeCount" label="点赞量" width="80" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.likeCount">
            {{ scope.row.likeCount }}
          </span>
          <span v-else>0</span>
        </template>
      </el-table-column>
      <!-- 文章发表时间 -->
      <el-table-column prop="createTime" label="发表时间" width="200" align="center">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span class="ml4">{{ scope.row.createTime | dateTime }} </span>
        </template>
      </el-table-column>
      <!-- 文章修改时间 -->
      <el-table-column prop="updateTime" label="更新时间" width="200" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.updateTime">
            <i class="el-icon-time" />
            <span class="ml4">{{ scope.row.updateTime | dateTime }}</span>
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <!-- 文章置顶 -->
      <el-table-column prop="topNum" label="置顶" width="100" align="center">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.isTop"
            active-color="#13ce66"
            inactive-color="#F4F4F5"
            :disabled="scope.row.isDelete === 1 || scope.row.isDraft === 1"
            :active-value="1"
            :inactive-value="0"
            @change="changeTop(scope.row)"
          />
        </template>
      </el-table-column>
      <!-- 列操作 -->
      <el-table-column label="操作" align="center" width="160">
        <template slot-scope="scope">
          <el-button v-hasPermi="['article:manage:edit']" size="mini" type="text"  icon="el-icon-edit" @click="editArticle(scope.row)" v-if="scope.row.isDelete === 0">编辑</el-button>
          <el-button v-hasPermi="['article:manage:recycle']" size="mini" type="text" icon="el-icon-delete" v-if="scope.row.isDelete === 0" @click="handleToRecycle(scope.row)">删除</el-button>
          <el-button v-hasPermi="['article:manage:back']" size="mini" type="text" icon="el-icon-refresh-left" v-if="scope.row.isDelete === 1" @click="handleBack(scope.row)">恢复</el-button>
          <el-button v-hasPermi="['article:manage:remove']" size="mini" type="text" icon="el-icon-delete" v-if="scope.row.isDelete === 1" @click="handleDeleteArticles(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.current"
      :limit.sync="queryParams.size"
      @pagination="getList"
    />
  </div>
</template>

<script>
import {
  getArticleList,
  moveToRecycle,
  backFromRecycle,
  removeArticle,
  updateArticleTop
} from "@/api/article/article";
export default {
  created() {
    this.getList();
  },
  data: function() {
    return {
      loading: true,
      showSearch: true,
      updateIsDelete: false,
      remove: false,
      options: [
        {
          value: '{"isDelete":0,"isDraft":0}',
          label: "已发布"
        },
        {
          value: '{"isDelete":1,"isDraft":null}',
          label: "回收站"
        },
        {
          value: '{"isDelete":0,"isDraft":1}',
          label: "草稿箱"
        }
      ],
      condition: '{"isDelete":0,"isDraft":0}',
      articleList: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      articleIds: [],
      articleTitles: [],
      queryParams: {
        current: 1,
        size: 10,
        keyWords: null,
        isDelete: 0,
        isDraft: 0
      },
      total: 0
    };
  },
  methods: {
    selectionChange(selection) {
      this.articleIds = selection.map(item => item.articleId);
      this.articleTitles = selection.map(item => item.articleTitle);
      this.single = selection.length !== 1;
      this.multiple = !selection.length;
    },
    changeType(item) {
      this.queryParams.isDelete = item.isDelete === 1 ? 1 : 0;
    },
    editArticle(row) {
      const articleId = row.articleId || this.articleIds;
      this.$tab.openPage('文章编辑', "/article/article-edit/",{articleId:articleId})
    },
    //删除到回收站
    handleToRecycle(row) {
      let ids = this.articleIds;
      let articleTitles = this.articleTitles;
      if (row.articleId) {
        ids = [row.articleId];
        articleTitles = [row.articleTitle];
      }
      let data = {
        ids: ids,
      };

      this.$modal.confirm('是否确认删除文章标题为"' + articleTitles + '"的数据项？').then(function(){
        return moveToRecycle(data)
      }).then(()=>{
        this.getList();
      }).catch(()=>{})
    },
    //恢复
    handleBack(row) {
      let ids = this.articleIds;
      let articleTitles = this.articleTitles;
      if (row.articleId) {
        ids = [row.articleId];
        articleTitles = [row.articleTitle];
      }
      let data = {
        ids: ids
      };

      this.$modal.confirm('是否确认恢复文章标题为"' + articleTitles + '"的数据项？').then(function(){
        return backFromRecycle(data)
      }).then(()=>{
        this.getList();
      }).catch(()=>{})
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.current = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.queryParams.isDelete = 0;
      this.queryParams.isDraft = 0;
      this.condition = '{"isDelete":0,"isDraft":0}';
      this.handleQuery();
    },
    //彻底删除
    handleDeleteArticles(row) {
      let ids = this.articleIds;
      let articleTitles = this.articleTitles;
      if (row.articleId) {
        ids = [row.articleId];
        articleTitles = [row.articleTitle];
      }
      this.$modal.confirm('是否确认彻底删除文章标题为"' + articleTitles + '"的数据项？').then(function() {
          return removeArticle({ ids: ids });
        }).then(() => {
          this.$modal.msgSuccess("删除成功");
          this.getList();
        }).catch(() => {});
    },
    changeTop(article) {
      let oper = article.isTop === 0 ? "取消置顶" : "置顶";
      let data = {
        id: article.articleId,
        isTop: article.isTop
      };
      updateArticleTop(data).then(res => {
        if (res.flag) {
          this.$modal.msgSuccess(oper + "成功");
          this.getList();
        }
      });
    },
    getList() {
      getArticleList(this.queryParams).then(res => {
        this.articleList = res.rows;
        this.total = res.total;
        this.loading = false;
      });
    }
  },
  watch: {
    condition() {
      const condition = JSON.parse(this.condition);
      this.queryParams.isDelete = condition.isDelete;
      this.queryParams.isDraft = condition.isDraft;
      this.handleQuery();
    }
  }
};
</script>
